import { render, staticRenderFns } from "./remote-training.vue?vue&type=template&id=4b4ce456&"
import script from "./remote-training.js?vue&type=script&lang=js&"
export * from "./remote-training.js?vue&type=script&lang=js&"
import style0 from "./remote-training.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports